import { useEffect } from 'react';
import { defaultSeo } from '../data/seo';

function Seo({
  title,
  description,
  image = '/assets/img/og-image.jpg',
  url = defaultSeo.siteUrl,
  canonical = true,
  schema,
  noIndex = false,
}) {
  const fullUrl = url.startsWith('http') ? url : `${defaultSeo.siteUrl}${url}`;
  const fullImage = image.startsWith('http') ? image : `${defaultSeo.siteUrl}${image}`;
  const fullTitle = title.includes('MH-BETON') ? title : `${title} | MH-BETON`;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name, content, property = false) => {
      let meta = document.querySelector(property ? `meta[property="${name}"]` : `meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        if (property) meta.setAttribute('property', name);
        else meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('og:type', 'website', true);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:image', fullImage, true);
    setMeta('og:url', fullUrl, true);
    setMeta('twitter:card', 'summary_large_image', true);
    setMeta('twitter:title', fullTitle, true);
    setMeta('twitter:description', description, true);
    setMeta('twitter:image', fullImage, true);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', fullUrl);
    }

    if (noIndex) {
      setMeta('robots', 'noindex, nofollow');
    }

    let schemaScripts = document.querySelectorAll('script[data-seo-schema]');
    if (schema) {
      const schemas = Array.isArray(schema) ? schema : [schema];
      schemaScripts.forEach((s) => s.remove());
      schemas.forEach((schemaItem) => {
        const script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.setAttribute('data-seo-schema', 'true');
        script.textContent = JSON.stringify(schemaItem);
        document.head.appendChild(script);
      });
    } else {
      schemaScripts.forEach((s) => s.remove());
    }

    return () => {
      document.querySelectorAll('script[data-seo-schema]').forEach((s) => s.remove());
    };
  }, [fullTitle, description, fullImage, fullUrl, canonical, noIndex, schema]);

  return null;
}

export default Seo;
